module.exports = __webpack_public_path__ + "static/media/apartment6.27957333.png";